import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';
import { PRODGY_CHART_COLORS } from '@/shared/constants/colors';
import { useChartTheme } from './chartTheme';

interface PieChartProps {
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  config: {
    xAxis?: string;
    yAxis?: string;
    groupBy?: string;
  };
}

export const PieChart = ({ data }: PieChartProps) => {
  const chart = useChartTheme();

  const chartData = data.series?.[0]?.data || data.data || [];

  const option: EChartsOption = {
    color: PRODGY_CHART_COLORS,
    backgroundColor: chart.background,
    textStyle: { color: chart.axisLabel },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
      backgroundColor: chart.tooltipBg,
      borderColor: chart.tooltipBorder,
      textStyle: {
        color: chart.tooltipText,
      },
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      textStyle: {
        color: chart.legendText,
      },
    },
    series: [
      {
        name: data.name || 'Data',
        type: 'pie',
        radius: '70%',
        data: chartData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
        label: {
          color: chart.axisLabel,
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: '100%', width: '100%' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};
